// extracted by mini-css-extract-plugin
var _1 = "FlyoverPreviewUpsellModal-module__fade-in___fZINl";
var _2 = "FlyoverPreviewUpsellModal-module__upsell___U7zES";
export { _1 as "fadeIn", _2 as "upsell" }
